import { Checkbox, Col, Progress, Row, Tooltip } from 'antd';
import { Rule } from 'antd/lib/form';
import React, { ReactElement } from 'react';
import { getDateWithTime } from '../../../utils/dateTimeUtils';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { EXTENDED_STATUS, NEW_UPLOAD_STATUS, progress, UPLOAD_STATUS } from '../../constants/crmConstants';
import { ReactComponent as CloseIcon } from '../../../assets/images/svg/i_close.svg';
import { ReactComponent as FileIcon } from '../../../assets/images/svg/i_file.svg';
import { UploadFile } from 'antd/lib/upload/interface';
import { submitAdmission } from '../../../store/actions/fileAction';
import { useDispatch, useSelector } from 'react-redux';
import { centeredNotification } from '../../../utils/utility';
import { RootState } from '../../../store';
import FormCheckBox from '../crmFormElement/FormCheckBox/FormCheckBox';
import { setBuddhimedSelectedFiles, setModalSwitch } from '../../../store/actions/newAdmissionAction';
import { getFileType } from '../../../utils/fileUploadUtils';

function BuddhiMedClassifiedUploadListItem({ file, index, onRemove, fileListLength, selectionAllowed = false,
  onSelectToggle, form, showCheckbox, showProgress }: any): ReactElement {
  const { selectedFiles, uploadedFiles } = useSelector((state: RootState): any => state.newAdmission);
  const dispatch = useDispatch();
  const rules: Rule[] = [];
  const [progress33, progress66, progress100] = progress;

  rules.push({ required: true });
  const { existingRecord, name, createdDate, status, extendedStatus, fileType = [], uid } = file;

  const onDownload = (aFile: UploadFile): any => {
    const { response } = aFile;
    if (response) {
      const { errorMsg, uploadedDetails, isSuccess } = response;
      if (isSuccess) {
        const { fileGuid, fileName } = uploadedDetails[0];
        centeredNotification(`${fileName} start downloading...`, 'success');
        dispatch(submitAdmission(fileGuid));
      } else {
        centeredNotification(errorMsg);
      }
    }
  };

  let customPercent = 0;
  if (status === UPLOAD_STATUS.uploading) {
    customPercent = progress33;
  } else if (status === UPLOAD_STATUS.done) {
    customPercent = (extendedStatus === EXTENDED_STATUS.verified
      || extendedStatus === EXTENDED_STATUS.uploaded || (!extendedStatus && status === UPLOAD_STATUS.done)) ? progress100 : progress66;
  }

  const changeSelection = (event: any, fileItem: any): any => {
    const checked = event?.target?.checked;
    let newData = [...selectedFiles];

    if (checked) {
      fileItem.isDeleted = false;
      fileItem.isRejected = false;
      fileItem.discrepancy = false;
      fileItem.existingRecord = false;
      newData?.push(fileItem);
      dispatch(setBuddhimedSelectedFiles(newData));
    } else {
      const objIndex = selectedFiles?.findIndex((obj: any): any => obj?.uid === fileItem?.uid);
      if (objIndex !== -1 && !checked) {
        selectedFiles?.splice(objIndex, 1);
        dispatch(setBuddhimedSelectedFiles(selectedFiles));
      } else {
        newData = [];
        dispatch(setBuddhimedSelectedFiles(newData));
      }
    }
    const newFileUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === NEW_UPLOAD_STATUS);
    // to enable/disable the submit button
    if (selectedFiles?.length > 0) {
      dispatch(setModalSwitch(false));
    } else if (selectedFiles?.length === 0 && newFileUploads?.length === 0) {
      dispatch(setModalSwitch(true));
    }
  };
  // for selected files getting set in the form
  if (selectedFiles?.length) {
    selectedFiles?.map((fileArr: any): any => {
      const currentFormValues = form?.getFieldsValue();
      if (fileArr?.uid) {
        currentFormValues[fileArr?.uid] = fileArr?.uid;
      }
      form.setFieldsValue(currentFormValues);
    });
  }

  return (
    <div className="upload-list">
      <Row gutter={GUTTOR_SPACE} style={{ marginLeft: '-21px', marginRight: '-72px' }}>
        <Col span={6} style={{ paddingLeft: '21px' }}>
          <div className="text-elipsis">
            <FileIcon className="fill-gray v-align-middle" />
            <span className="text-primary">
              <a onClick={(): void => onDownload(file)}>
                <Tooltip placement="right" title={name?.length > 16 ? name : null} mouseEnterDelay={0.8}>
                  {name}
                </Tooltip>
              </a>
            </span>
          </div>
        </Col>
        <Col span={4}>
          {(createdDate && showCheckbox) ? new Date(createdDate)?.toISOString()?.split('T')?.[0]
            : createdDate || getDateWithTime(new Date())}
        </Col>
        {<>
          <Col span={3} className="circular-progress" style={{ paddingLeft: '51px' }}>
            {<Progress type="circle" percent={customPercent} width={20} />}
          </Col>
          {/* <Col md={3}> */}
          {/* <Col span={2}>
            <span className="text-primary bold fsize_sm" style={{marginLeft:'-28px'}}>
              {getFileStatus()}
            </span>
          </Col> */}
        </>}
        {/* <Col md={4}> */}
        <Col span={4} style={{ marginLeft: '-25px' }}>
          {getFileType(fileType)}
        </Col>
        {!showCheckbox ?
          <Col md={4} style={{ paddingLeft: '70px' }}>
            {!existingRecord ? <Tooltip title="Remove"><CloseIcon data-testid={`${file.uid}-remove`} className="fill-close v-align-middle mouse-pointer"
              onClick={(): void => onRemove(uid)} /></Tooltip> : null}
            {selectionAllowed ? <Tooltip title="Select"><Checkbox className="v-align-middle mouse-pointer"
              onClick={(): void => onSelectToggle(uid)} /></Tooltip> : null}
          </Col> :
          <Col span={6} className="selected-checkbox">
            <FormCheckBox
              detail={{
                key: file?.uid,
                options: [{
                  value: file?.uid, key: file?.uid, name: '', required: false, onChange: (event: any): any => changeSelection(event, file),
                }],
                size: 20,
                hideLabel: true,
                checked: false,
              }}
            />
          </Col>
        }
      </Row>
    </div>
  );
}

export default BuddhiMedClassifiedUploadListItem;
